
    import { Component, Vue } from 'vue-property-decorator';
    import InputText from '@/components/form/Input-text.vue';
    import InputSelect from '@/components/form/Input-select.vue';
    import { ApiRepository } from '@/api';

    @Component({
        components: {InputSelect, InputText},
        props: {
            keys: Object,
            dates: Array,
            selects: Object,
            isexport: Boolean,
            relations: Array,
            appPart: String
        },
    })
    export default class TableFilter extends Vue {
        private inputParams: any = {};
        private opened: boolean = true;

        public created() {
          if (this.$props.appPart === 'applications' && this.$store.getters.appFilters) {
            this.setFiltersFromStore(this.$store.getters.appFilters)
          }
        }

        private setFiltersFromStore(filters: any) {
          let storeFilters: any = {};
          filters.split(',').forEach((filter: string) => {
            let splFilter = filter.split(':');
            if (splFilter.length === 2) {
              storeFilters[splFilter[0]] = splFilter[1];
            }
          })
          this.inputParams = storeFilters;
        }

        private submitFilter(event: any) {
            event.preventDefault();
            this.$emit('setFilter', this.inputParams);
        }

        private clearFilter() {
            this.$emit('setFilter', null);
            this.inputParams = {};
        }

        private isDate(key: any) {
            if (!this.$props.dates) {
                return true;
            }

            return !this.$props.dates.includes(key);
        }

        private isSelect(key: any) {
            if (!this.$props.selects) {
                return false;
            }
            return Object.keys(this.$props.selects).includes(key);
        }
        private async exports(){
            const filters: any = [];

            if (this.inputParams) {
                Object.keys(this.inputParams).forEach((key: string) => {
                  if (key !== 'page' && key !== 'take') {
                    filters.push(key + ':' + this.inputParams[key]);
                  }
                });
            }
            const strFilter = filters.join(',');
            await this.sendRequest({
                filters: strFilter
            });
        }

        private async sendRequest(params: object = {}) {
            if (this.$props.relations) {
                params = {
                    relations: this.$props.relations,
                    ...params
                };
            }

            const response = await ApiRepository.exportApplications(params);

            const a = document.createElement('a')
            a.href = 'data:text/csv;base64,' + response
            a.download = 'exportApplication' + new Date().getTime() + '.csv'
            a.click();
        }
    }
